/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
`;
